import React, { createContext, useContext, useEffect, useState } from 'react';
import { offerConfig } from '../data/siteConfig';
import { formatARS } from '../utils/currency';
type OfferContextValue = {
  secondsLeft: number;
  expired: boolean;
  price: number;
  priceLabel: string;
  previousPriceLabel: string;
};
const STORAGE_KEY = 'v360_offer_deadline';
const DURATION_MS = offerConfig.reservationMinutes * 60 * 1000;
const OfferContext = createContext<OfferContextValue | null>(null);
export function OfferProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [deadline] = useState(readDeadline);
  const [now, setNow] = useState(() => Date.now());
  const remainingMs = Math.max(0, deadline - now);
  const expired = remainingMs === 0;
  useEffect(() => {
    if (expired) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [expired]);

  // El precio vigente es siempre el de lanzamiento: el timer no cambia el precio.
  const value: OfferContextValue = {
    secondsLeft: Math.ceil(remainingMs / 1000),
    expired,
    price: offerConfig.launchPrice,
    priceLabel: formatARS(offerConfig.launchPrice),
    previousPriceLabel: formatARS(offerConfig.previousPrice)
  };
  return <OfferContext.Provider value={value} data-id="element-329" data-mp="19vtyr8es06zu">{children}</OfferContext.Provider>;
}
export function useOffer(): OfferContextValue {
  const ctx = useContext(OfferContext);
  if (!ctx) throw new Error('useOffer debe usarse dentro de OfferProvider');
  return ctx;
}

// Vencimiento guardado por sesión: si recarga la página conserva el tiempo restante.
function readDeadline(): number {
  try {
    const stored = Number(window.sessionStorage.getItem(STORAGE_KEY));
    if (Number.isFinite(stored) && stored > 0) return stored;
    const deadline = Date.now() + DURATION_MS;
    window.sessionStorage.setItem(STORAGE_KEY, String(deadline));
    return deadline;
  } catch {
    return Date.now() + DURATION_MS;
  }
}